import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import { AddNewClient } from '../Clients/addNewClient.api';

const firebaseRef = firebase.database();

export default async function addLeadToClient(
	leadEmail,
	setAlert,
	snackbar,
	setSnackbar,
	setSnackbarType
) {
	var leadObject;

	//getting the lead email object
	await firebaseRef
		.ref('/kavtek_leads/')
		.orderByChild('clientEmail')
		.equalTo(leadEmail)
		.once('value', (snapshot) => {
			var leadKeys = Object.keys(snapshot.val());
			var leadObjectInFirebase;

			leadKeys.forEach((leadKey) => {
				leadObjectInFirebase = snapshot.val()[leadKey];
			});

			leadObject = {
				email: leadEmail,
				clientName: leadObjectInFirebase.clientFName,
				phoneNumber: leadObjectInFirebase.clientPhoneNumber,
			};
		});

	//get if emails already exist in existing clients. Can use addNewClient.api.js
	const { email, clientName, phoneNumber } = leadObject;
	AddNewClient(
		clientName,
		email,
		phoneNumber,
		(returned) => console.log(returned),
		(returned) => console.log(returned)
	);

	setAlert('Client Added');
	setSnackbar(true);
	setSnackbarType('warning');
}
